export default "<div id='editor' #editor class=\"monaco-editor\"></div>"